import React, {useEffect, useState} from 'react'
import styles from './styles.module.css'
import TitleAndDesc from '../../components/TitleAndDesc/TitleAndDesc'
import {getMessages, setPage} from '../../actions/messages'
import {useDispatch, useSelector} from 'react-redux'
import {Pagination} from '../../components/Pagination'
import Modal from './Modal'
import Table from '../../components/Table'
import Empty from '../../components/Empty'
import Search from '../../components/Search'
import Card from './Card'
import moment from 'moment'
import {Link} from 'react-router-dom'
import { chatList } from '../../assets/const'

const body = [
    [
        {
            placeholder: 'Дата с',
            name: 'date_from',
            type: 'date',
            style: {
                maxWidth: '200px'
            }
        }, {
            placeholder: 'Дата по',
            name: 'date_to',
            type: 'date',
            style: {
                maxWidth: '200px'
            }
        }, {
            placeholder: 'Поиск',
            name: 'searchstring',
            type: 'text',
            style: {
                maxWidth: '100%'
            }
        }
    ]
]

export default function Chats() {

    const dispatch = useDispatch()
    // const {list, list_loading, pageNumber, pageCount} = useSelector(state =>
    // state.messages)
    
    const {itemsOnPage} = useSelector(state => state.auth)
    const [modal,
        setModal] = useState(false)
    const [params,
        setParams] = useState({
        searchstring: '',
        date_from: null,
        date_to: null
    });

    useEffect(() => {
        dispatch({type:'SET_CHAT', payload: modal})
    }, [modal.id])

    const handleFilteredList = (list) => {
        // Проверяем, что list существует и является массивом
        if (!Array.isArray(list)) {
            console.error("Invalid input: 'list' must be an array.");
            return [];
        }
    
        // Получаем параметры поиска и даты, учитывая их возможное отсутствие
        const searchString = params.searchstring ? params.searchstring.toLowerCase() : '';
        const dateFrom = params.date_from ? moment(params.date_from) : null;
        const dateTo = params.date_to ? moment(params.date_to) : null;
    
        // Фильтруем список
        return list.filter((elem) => {
            // Проверяем, соответствует ли элемент строке поиска
            const matchesSearchString =
                !searchString ||
                (elem.title?.toLowerCase().includes(searchString) ||
                 elem.text?.toLowerCase().includes(searchString));
    
            // Проверяем, соответствует ли элемент диапазону дат
            const matchesDateRange =
                (!dateFrom || moment(elem.date).isSameOrAfter(dateFrom)) &&
                (!dateTo || moment(elem.date).isSameOrBefore(dateTo));
    
            // Возвращаем true, если элемент проходит оба условия
            return matchesSearchString && matchesDateRange;
        });
    };

    // useEffect(() => {     pageClick({selected: 0}) }, []) useEffect(() => {
    // dispatch(getMessages({...params, date_to: params.date_to + ' 23:59:59'})) },
    // [itemsOnPage, params, pageNumber])

    const pageClick = ({selected}) => dispatch(setPage(selected))

    return (
        <div className={styles.wrapper}>
            <TitleAndDesc title="История чатов"/>

            <Modal modal={modal} setModal={setModal}/>

            <Search params={params} setParams={setParams} body={body}/>

            <div className={styles.list}>
                {chatList.length > 0
                    ? handleFilteredList(chatList).map(item => <Card setModal={setModal} item={item} key={item.id}/>)
                    : <Empty/>
}
            </div>
        </div>
    )
}
